import type { IconSvgObject } from './types';

const BodyPartLegIcon: IconSvgObject = [
  ["path", { d: "M5.00195 2C7.60131 2.30287 16.3716 3.88634 19.6709 11.2018C19.8972 11.7037 19.8627 12.2802 19.6203 12.7747L15.0989 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.00195 12C4.99805 13 7.99805 14.5 11.998 14C10.498 14.099 7.62695 16.8 7.62695 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.00195 7C8.00195 7.5 9.50195 8 12 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BodyPartLegIcon;
